"use client";
import React, { useEffect, useState } from "react";
import DynamicWizard, { WizardStep } from "@/components/dynamicWizard";

import Footer from "@/components/layout/footer";
import Header from "@/components/layout/header";
import { WizardService } from "@/services/wizard";
import BlogCategory from "@/components/blogCategory";

const Quiz = () => {
  const [steps, setSteps] = useState<WizardStep[]>([]);

  const handleComplete = (answers: Record<string, string | string[]>) => {
    console.log("User responses:", answers);
    // TODO: Submit data to API or redirect to recommendations
  };

  useEffect(() => {
    const wizardFetch = async () => {
      const stp = await WizardService.wizardList();
      console.log(stp)
      setSteps(stp)
    }
    wizardFetch();
  }, [])

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="min-h-screen bg-gray-50 py-10 px-4 topHome">
        <h1 className="text-3xl font-bold text-center text-primary mb-6">
          Personalize your Only Life
        </h1>
        <DynamicWizard steps={steps} onComplete={handleComplete} />

        <div className="mt-12 pt-8">
          <BlogCategory></BlogCategory>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Quiz;
